import { render, staticRenderFns } from "./Strain4chThresholdForm.vue?vue&type=template&id=c53b46ec&"
import script from "./Strain4chThresholdForm.vue?vue&type=script&lang=js&"
export * from "./Strain4chThresholdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports